import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const RouteMiniMapStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M24 9.33398C32.0997 9.33416 38.6658 15.8725 38.666 23.9375C38.666 24.5907 38.6068 25.2258 38.5215 25.8564L36.3486 24.9697C36.3753 24.6299 36.3994 24.2853 36.3994 23.9375C36.3992 17.1297 30.8371 11.591 24 11.5908C20.2108 11.5908 16.817 13.2953 14.541 15.9717H27.9922C31.5385 15.9721 33.3167 20.2164 30.8555 22.7295L28.5879 21.8047L29.9023 20.4951C30.7396 19.6614 30.1446 18.2318 28.958 18.2305L13.0146 18.2285C12.1146 19.9372 11.5986 21.879 11.5986 23.9395C11.5987 27.9633 13.5505 31.5335 16.5518 33.7891L21.8525 28.5098L22.7852 30.7725L18.5342 35.0049C20.1862 35.8174 22.036 36.2861 24 36.2861C24.3477 36.2861 24.6902 36.2626 25.0312 36.2334L25.9238 38.3984C25.2933 38.4821 24.6532 38.542 24 38.542C15.9 38.542 9.33301 32.0028 9.33301 23.9375C9.33319 15.8723 15.9001 9.33398 24 9.33398ZM22.7891 24.8271C22.2491 23.5341 23.5903 22.1934 24.8916 22.7363L38.4561 28.2715L37.6895 30.1084L31.3076 31.2236L30.1943 37.5723L28.3467 38.333L22.7891 24.8271Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
